import { HttpTypes } from '@/types';
import { AxiosInstance, AxiosRequestConfig } from 'axios';

class PaymentChannels {
  private client: AxiosInstance;
  private routePath = '/sites';
  public host = '';

  constructor(client: AxiosInstance) {
    client.interceptors.request.use();

    this.client = client;
  }

  interceptRequest(config: AxiosRequestConfig) {
    config.headers = {
      ...config.headers,
    };

    return config;
  }

  async get(): Promise<HttpTypes.IResponse<any>> {
    this.interceptRequest({ ...this.client.request });
    const result = await this.client.get(`${this.routePath}/payment-channels`, {
      headers: {
        Origin: this.host,
        'X-Jstore-Host': this.host,
      },
    });
    return result.data;
  }
}

export default PaymentChannels;
